import { Component } from '@angular/core';

@Component({
  selector: 'app-not-found',
  imports: [],
  templateUrl: '../ui/not-found.component.html'
})
export class NotFoundComponent {

}
